"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMsgConvertERC20 = exports.MSG_CONVERT_ERC20_TYPES = void 0;
exports.MSG_CONVERT_ERC20_TYPES = {
    MsgValue: [
        { name: 'contract_address', type: 'string' },
        { name: 'amount', type: 'string' },
        { name: 'receiver', type: 'string' },
        { name: 'sender', type: 'string' },
    ],
};
function createMsgConvertERC20(contractAddress, amount, receiver, sender) {
    return {
        type: 'evmos/MsgConvertERC20',
        value: {
            contract_address: contractAddress,
            amount,
            receiver,
            sender,
        },
    };
}
exports.createMsgConvertERC20 = createMsgConvertERC20;
//# sourceMappingURL=msgConvertERC20.js.map